"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("../models/globals");
const boutons_1 = require("../outils/boutons");
const fichiers_1 = require("../models/fichiers");
class Documents extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "documents",
            datatableName: "listeFichiersDatatable",
            columns: fichiers_1.fichiersColumns,
            title: (0, globals_1._)("Liste des documents"),
            boutons: [boutons_1.ouvrirButton],
            resizeColumn: true,
            urlData: globals_1.phpPath + "fichiers.php?option=list"
        });
    }
    ouvrir() {
        let vv = this.currentGrid.getSelectedId(false, false);
        if (!vv) {
            webix.message((0, globals_1._)("Aucune ligne n'est sÃ©lectionnÃ©e"));
            return;
        }
        let record = this.currentGrid.getItem(vv.row);
        let idDoc = record.idDocument;
        // @ts-ignore
        webix.ajax().response("blob").get(globals_1.phpPath + "/printing/document.php?unid=" + idDoc, function (text, data) {
            // @ts-ignore
            webix.html.download(data, "document.pdf");
        });
        // promise.catch(function(reason) {
        // 	// reason est l'origine de l'action : cellule du tableau
        // 	webix.message(_("Erreur de rÃ©cupÃ©ration du document"));
        // })
    }
    init() {
        this.currentGrid = $$(this.datatableName);
        let me = this;
        if ((globals_1.lv2.droits).includes("fichiers.list")) {
            this.currentGrid.attachEvent("onItemDblClick", function () {
                me.ouvrir();
            });
        }
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "ouvrirButton":
                    me.ouvrir();
                    break;
            }
        });
    }
    ready() {
        let me = this;
        let menu = this.$$("stdGridMenu");
        if ((globals_1.lv2.droits).includes("fichiers.liste")) {
            menu.showMenuItem("ouvrirButton");
        }
    }
}
exports.default = Documents;
